import { FactoryIcon, UserIcon } from '@fronton/icons-react';

export const PARAGRAPHS_TEXT = [
	'Мы заботимся о том, чтобы ваши инструменты служили долго. Если что‑то пошло не так — мы вам поможем!',
	'В каждом магазине Лемана ПРО для вас открыт Сервисный Центр, который находится на стойке Центра по Обслуживанию Клиентов',
];

export const WARRANTY = [
	'Гарантия означает, что мы бесплатно исправим проблемы с вашим инструментом, если они возникли не по вашей вине',
];

export const WARRANTY_CARDS = [
	{
		title: 'Приёмка и отправка',
		description:
			'Принесите инструмент в наш сервисный центр. Мы проверим документы, проведём осмотр и передадим его в авторизованный сервис производителя. Вы получите на руки заявление о приёме',
	},
	{
		title: 'Диагностика и ремонт',
		description:
			'Специалисты сервиса проведут полную диагностику и выполнят ремонт строго по техническим стандартам бренда',
	},
	{
		title: 'Возврат и выдача',
		description:
			'Как только инструмент вернётся к нам, мы сразу же сообщим вам о готовности. Останется только заехать и забрать его',
	},
];

export const BAYER_CARDS = [
	{
		icon: UserIcon,
		title: 'Для физических лиц',
		description:
			'Приходите с ранее выданным заявлением на передачу товара в тот же сервисный центр',
	},
	{
		icon: FactoryIcon,
		title: 'Для организаций',
		description:
			'Понадобятся паспорт представителя, доверенность и заявление на передачу товара',
	},
];

export const TAKE_WITH_YOU = {
	title: 'Что взять с собой',
	list: [
		'Чек, номер заказа или действующую Ключ-карту / Ключ-карту ПРО',
		'Полную комплектацию (инструмент, аккумулятор, зарядное устройство)',
	],
};

export const HOW_NOT_LOST_WARRANTY = {
	title: 'Как не потерять гарантию',
	list: [
		'Воздержитесь от самостоятельного ремонта или вскрытия корпуса',
		'Обращайтесь только в авторизованные сервисные центры',
	],
};

export const USEFUL_VISIT = {
	title: 'При визите будет полезно',
	list: [
		'Кратко описать проблему',
		'Оставить контакты для связи: телефон, email и почтовый адрес для уведомлений',
	],
};

export const SOPHISTICATED_EQUIPMENT = [
	'Установка, ремонт и замена газовых плит, котлов и водонагревателей должны выполняться только аттестованными специалистами. Это требование безопасности, которое исключает самостоятельный монтаж',
];

export const GOOD_NEWS = [
	'На всё время, пока ваш инструмент находится в ремонте, срок гарантии автоматически продлевается',
];
